// extracted by mini-css-extract-plugin
export default {"cropContainer":"EndNegotiation_cropContainer__L6dmm","buttons":"EndNegotiation_buttons__2Kvu8"};